// extracted by mini-css-extract-plugin
module.exports = {"Button":"SecondaryButton_Button__1ZToX"};